import { Button, TableCell } from "@material-ui/core";
import React, { ReactNode } from "react";
import { HeaderCellProps } from "./HeaderCellProps";
import { headerCellStyles } from "./HeaderCellStyles";
import { ReactComponent as ChevronDown } from "icons/ChevronDown.svg";
import { ReactComponent as ChevronUp } from "icons/ChevronUp.svg";
import { observer } from "mobx-react";
import clsx from "clsx";

export default observer(function HeaderCell({
    id,
    headerTitle,
    sortable,
    onSortChange = () => {},
    align,
    currentSortColumn,
    currentSortDirection,
}: HeaderCellProps) {
    const isSortedBy = id === currentSortColumn;

    const classes = headerCellStyles({ isSortedBy });

    let sortIcon: ReactNode | null = null;

    if (sortable) {
        sortIcon = <ChevronDown className={classes.icon} />;

        if (isSortedBy && currentSortDirection === "DESC") {
            sortIcon = <ChevronUp className={classes.icon} />;
        }
    }

    const handleClick = () => {
        onSortChange(
            isSortedBy && currentSortDirection === "ASC" ? "DESC" : "ASC"
        );
    };

    return (
        <TableCell
            align={align}
            className={clsx(classes.root, classes.typography)}
        >
            {sortable ? (
                <Button
                    onClick={handleClick}
                    className={clsx(classes.button, classes.typography)}
                >
                    {headerTitle}
                    {sortIcon}
                </Button>
            ) : (
                headerTitle
            )}
        </TableCell>
    );
});
